import React, { PropsWithoutRef, useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Menu,
  MenuItem,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import KeyIcon from "@mui/icons-material/Key";

import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";
import { SIDEBAR_WIDTH } from "../constants";
import "./Layout.scss";
import { useAppDispatch, useAppSelector } from "../hooks/store";
import { useLazyGetProfileQuery, useLogoutUserMutation } from "../service/auth";
import {
  errorToast,
  getFromStorage,
  removeFromStorage,
  successToast,
} from "../helpers";
import { STORAGE_KEYS } from "../constants/storageKeys";
import { setCredentials } from "../reducers/authSlice";
import { ChangePasswordModal } from "../Modals/changePassword";
import {
  getNotificationCount,
  setUnreadNotificationCount,
} from "../reducers/generalSlice";

interface Props {
  handleSidebarToggle: () => void;
}

function Topbar({ handleSidebarToggle }: PropsWithoutRef<Props>) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [logoutMethod] = useLogoutUserMutation();
  const [getUser] = useLazyGetProfileQuery();
  const notificationCount = useAppSelector(getNotificationCount);

  console.log(notificationCount, "notificationCountnotificationCount");

  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (window) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);
  const [user, setUser] = useState(null) as any;

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    try {
      const res = await logoutMethod().unwrap();
      if (res.status == 200) {
        successToast("Logout Successful");
        removeFromStorage(STORAGE_KEYS.token);
        removeFromStorage(STORAGE_KEYS.tempToken);
        dispatch(
          setCredentials({
            user: null,
            token: null,
          })
        );
        navigate("/", { replace: true });
      }
    } catch (error: any) {
      errorToast(error?.data?.message);
    }
  };

  const getUserDetails = async () => {
    const token = await getFromStorage(STORAGE_KEYS.token);

    if (token) {
      try {
        const result = await getUser().unwrap();
        if (result?.status === 200 && token) {
          setUser(result?.data || null);
          dispatch(
            setCredentials({
              user: result?.data,
              token: token,
            })
          );

          if (typeof result?.data?.unread_notification === "number") {
            dispatch(
              setUnreadNotificationCount(result?.data?.unread_notification)
            );
          }
        }
      } catch (error) {
        errorToast(error?.data?.message || "");
      }
    }
  };

  useEffect(() => {
    const token = getFromStorage(STORAGE_KEYS.token);
    const userData = getFromStorage(STORAGE_KEYS.credentials);

    if (token) {
      dispatch(
        setCredentials({
          token: `${token}`,
          user: JSON.parse(`${userData}`),
        })
      );
      getUserDetails();
    }
  }, []);

  return (
    <Box className="site_header">
      <AppBar
        position="fixed"
        className="topbar"
        sx={{
          width: { lg: `calc(100% - ${SIDEBAR_WIDTH}px)` },
          ml: { lg: `${SIDEBAR_WIDTH}px` },
        }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          <div className="topbar_left">
            <IconButton
              color="inherit"
              aria-label="open sidebar"
              edge="start"
              onClick={handleSidebarToggle}
              sx={{
                display: { lg: "none" },
              }}
            >
              <MenuIcon />
            </IconButton>
          </div>
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              flexGrow: 1,
              justifyContent: "flex-end",
              gap: "20px",
            }}
          >
            <Box>
              <IconButton
                className="icon_btn"
                onClick={() => navigate("/recieved-notifications")}
              >
                <img src="/static/images/notification_icon.png" alt="Icon" />
                {notificationCount === 0 ? null : (
                  <div className="item_count1">{notificationCount}</div>
                )}
              </IconButton>
            </Box>

            <Box>
              <IconButton
                className="topbar_user_btn"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
              >
                <img
                  src={
                    user?.profile_picture?.media_url
                      ? user?.profile_picture?.media_url
                      : "/static/images/user_placeholder.png"
                  }
                  alt=""
                />
              </IconButton>
              <Menu
                className="userDropdown_menu"
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 15,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem
                  className="userDropdown_menu_list"
                  onClick={() => navigate("/my-profile")}
                >
                  <IconButton className="drpdwn_icns">
                    <PersonIcon />
                  </IconButton>
                  My Profile
                </MenuItem>
                <MenuItem
                  className="userDropdown_menu_list"
                  onClick={() => setOpenModal(true)}
                >
                  <IconButton className="drpdwn_icns">
                    <KeyIcon />
                  </IconButton>
                  Change Password
                </MenuItem>

                <MenuItem
                  className="userDropdown_menu_list"
                  onClick={() => handleLogout()}
                >
                  <IconButton className="drpdwn_icns">
                    <LogoutIcon />
                  </IconButton>
                  Logout
                </MenuItem>
              </Menu>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <ChangePasswordModal
        open={openModal}
        handleClose={() => setOpenModal(false)}
      />
    </Box>
  );
}

export default Topbar;
